// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPaymentRuleRenewalDto
 */
export interface IPaymentRuleRenewalDto {
    /**
     * 
     * @type {number}
     * @memberof IPaymentRuleRenewalDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPaymentRuleRenewalDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IPaymentRuleRenewalDto
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof IPaymentRuleRenewalDto
     */
    max_amount?: number;
}

/**
 * Check if a given object implements the IPaymentRuleRenewalDto interface.
 */
export function instanceOfIPaymentRuleRenewalDto(value: object): value is IPaymentRuleRenewalDto {
    return true;
}

export function IPaymentRuleRenewalDtoFromJSON(json: any): IPaymentRuleRenewalDto {
    return IPaymentRuleRenewalDtoFromJSONTyped(json, false);
}

export function IPaymentRuleRenewalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPaymentRuleRenewalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'max_amount': json['max_amount'] == null ? undefined : json['max_amount'],
    };
}

export function IPaymentRuleRenewalDtoToJSON(json: any): IPaymentRuleRenewalDto {
    return IPaymentRuleRenewalDtoToJSONTyped(json, false);
}

export function IPaymentRuleRenewalDtoToJSONTyped(value?: IPaymentRuleRenewalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'plan_name': value['plan_name'],
        'percentage': value['percentage'],
        'max_amount': value['max_amount'],
    };
}

